import { render, staticRenderFns } from "./d2-container-ghost-bs.vue?vue&type=template&id=95d28ce4&"
import script from "./d2-container-ghost-bs.vue?vue&type=script&lang=js&"
export * from "./d2-container-ghost-bs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\english\\new-evaluation\\src\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95d28ce4')) {
      api.createRecord('95d28ce4', component.options)
    } else {
      api.reload('95d28ce4', component.options)
    }
    module.hot.accept("./d2-container-ghost-bs.vue?vue&type=template&id=95d28ce4&", function () {
      api.rerender('95d28ce4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/d2-container/components/d2-container-ghost-bs.vue"
export default component.exports